import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const TOKEN_KEY = "rips_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const authHeader = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

// Public
export const fetchWallets = () => api.get("/wallets").then((r) => r.data);

// Admin
export const adminLogin = (password) =>
  api.post("/admin/login", { password }).then((r) => r.data.token);

export const verifyAdmin = () =>
  api.get("/admin/verify", { headers: authHeader() }).then((r) => r.data);

export const createWallet = (data) =>
  api.post("/admin/wallets", data, { headers: authHeader() }).then((r) => r.data);

export const updateWallet = (id, data) =>
  api.put(`/admin/wallets/${id}`, data, { headers: authHeader() }).then((r) => r.data);

export const deleteWallet = (id) =>
  api.delete(`/admin/wallets/${id}`, { headers: authHeader() }).then((r) => r.data);
